import { useQuery } from '@tanstack/react-query';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useCommunicationChatApi } from '@/features/api/hooks/communication-chat/useCommunicationChatApi';
import { useAuth } from '@/features/authorization/provider/useAuth';

export const useGetChat = (id: string) => {
  const { isAuthenticated } = useAuth();
  const api = useCommunicationChatApi();

  return useQuery({
    queryKey: [API_CACHE_KEYS.CHAT, id],
    queryFn: () => api.getChat({ chatId: id }),
    enabled: isAuthenticated
  });
};
